export const STYLED_ACTION_GLOBAL_CLASS = 'styled-action-global';

export const makeCssStringFromObj = (obj: Record<string, string>): string =>
  Object.entries(obj)
    .map(([k, v]) => `${k}:${v}`)
    .join(';');
